import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/userSlice';

import {
  FaTachometerAlt,
  FaList,
  FaUserPlus,
  FaUsers,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from 'react-icons/fa';

import '../styles/Sidebar.css';

const Sidebar = () => {
  const [isOpen, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/client-login');
  };

  const close = () => setOpen(false);

  const menuItems = [
    { to: '/dashboard', icon: <FaTachometerAlt />, text: 'Dashboard' },
    { to: '/manage-device', icon: <FaList />, text: 'Manage Devices' },
    { to: '/add-user', icon: <FaUserPlus />, text: 'Add User' },
    { to: '/manage-user', icon: <FaUsers />, text: 'Manage Users' },
  ];

  return (
    <>
      {/* Mobile top bar — only visible on phones; holds the hamburger that opens the drawer */}
      <header className="mobile-topbar d-flex d-md-none">
        <button
          type="button"
          className="mobile-burger"
          aria-label="Open menu"
          onClick={() => setOpen(true)}
        >
          <FaBars />
        </button>
        <img src="/images/logo.png" alt="Alphatech Logo" className="mobile-topbar-logo" />
      </header>

      <aside className={`sidebar shadow-sm ${isOpen ? 'open' : ''}`}>
        {/* Logo + close button (close only shown on mobile) */}
        <div className="sidebar-brand">
          <img
            src="/images/logo.png"
            alt="Alphatech Logo"
            className="sidebar-logo"
          />

          <button
            type="button"
            className="sidebar-burger d-md-none"
            aria-label="Close menu"
            onClick={close}
          >
            <FaTimes />
          </button>
        </div>

        {/* Sidebar nav */}
        <nav className="sidebar-nav">
          <Nav as="ul" className="flex-column flex-grow-1">
            {menuItems.map(({ to, icon, text }) => (
              <Nav.Item as="li" key={to} style={{ marginBottom: 18 }}>
                <NavLink
                  to={to}
                  className="sidebar-link"
                  onClick={close}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 18,
                    padding: '14px 24px',
                    fontSize: 18
                  }}
                >
                  <span className="sidebar-icon">{icon}</span>
                  <span className="sidebar-text">{text}</span>
                </NavLink>
              </Nav.Item>
            ))}

            {/* Logout */}
            <Nav.Item as="li" className="mt-auto" style={{ marginBottom: 18 }}>
              <button
                type="button"
                onClick={handleLogout}
                className="sidebar-link logout-link w-100 border-0 bg-transparent"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 18,
                  padding: '14px 24px',
                  fontSize: 18
                }}
              >
                <span className="sidebar-icon">
                  <FaSignOutAlt />
                </span>
                <span className="sidebar-text">Logout</span>
              </button>
            </Nav.Item>
          </Nav>
        </nav>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="sidebar-overlay d-md-none"
          onClick={close}
        />
      )}
    </>
  );
};

export default Sidebar;
